import AfterFetchComponent from '@/components/base/AfterFetchComponent'
import EditDocumentsComponents from "@/components/dashboard/loans-management/EditDocuments.vue";
import PersonalDetailsComponent from "@/components/dashboard/loans-management/PersonalDetails.vue";
import StatusesHistoryTableComponent from "@/components/dashboard/loans-management/StatusesHistoryTable.vue";
import StatusesManagementComponent from "@/components/dashboard/loans-management/StatusesManagement.vue"
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import i18n from "@/lang/lang";
import {LoanManagementModel} from "@/models/LoansManagement"
import {ExportType} from '@payroll/grid-widget/src/models/ExportType'
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {BaseRequest, KeyValuePair} from '@payroll/optimus-common'
import {FieldType, SearchFieldModel} from '@payroll/search-results-widget/src/models/SearchField.model'
import Component from 'vue-class-component'
import {Action, Getter, Mutation} from 'vuex-class'

@Component({
  components: {
    PersonalDetailsComponent,
    StatusesManagementComponent,
    StatusesHistoryTableComponent,
    EditDocumentsComponents
  }
})
export default class LoansManagementComponent extends AfterFetchComponent {

  @Action('getProcesses', StoreNamespace.PROCESSES) getProcesses: any
  @Action('fetchLoanRequest', StoreNamespace.PROCESSES) fetchLoanRequest: any

  @Action('downloadLoanApplication', StoreNamespace.PROCESSES) downloadLoanApplication: any
  @Action('downloadLoanRatingType', StoreNamespace.PROCESSES) downloadLoanRatingType: any
  @Action('approveApplications', StoreNamespace.PROCESSES) approveApplications: any
  @Action('rejectApplication', StoreNamespace.PROCESSES) rejectApplication: any
  @Action('underExaminationApplication', StoreNamespace.PROCESSES) underExaminationApplication: any
  @Action('getLoansManagementSettings', StoreNamespace.PROCESSES) getLoansManagementSettings: any
  @Action('getAllStatusOptions', StoreNamespace.PROCESSES) getAllStatusOptions: any
  @Action('getAttachedFiles', StoreNamespace.PROCESSES) getAttachedFiles: any
  @Action('createOrUpdateCompanyDocuments', StoreNamespace.PROCESSES) createOrUpdateCompanyDocuments: any
  @Action('updateAttachedFiles', StoreNamespace.PROCESSES) updateAttachedFile: any
  @Action('updateLoanProcessPdf', StoreNamespace.PROCESSES) updateLoanProcessPdf: any
  @Action('exportLoansDetails', StoreNamespace.PROCESSES) exportLoansDetails: any

  @Action('hasExistMoreThenOneRequest', StoreNamespace.PROCESSES) hasExistMoreThenOneRequest: any
  @Action('getChangesHistories', StoreNamespace.PROCESSES) getChangesHistories: any


  @Getter('loansManagement', StoreNamespace.PROCESSES) loansManagement!: LoanManagementModel;
  @Getter('loanApprovalDetails', StoreNamespace.PROCESSES) loanApprovalDetails!: any;

  @Mutation('setLoanApprovalDetails', StoreNamespace.PROCESSES) setLoanApprovalDetails!: any;


  private searchLoansFields: SearchFieldModel[] = []
  private columns: GridColumn[] = []
  private rejectStatuses: any[] = [];
  private underExaminationStatuses: any[] = [];
  private rejectStatusesSelection: any[] = [];
  private underExaminationStatusesSelection: any[] = [];
  private processTypeCode: string | null = '';
  private memberProcessId: number = 0;
  private description: string | null = '';
  private rowSelected: any = {loanApprovalDetailsFormData: {}};
  private showSingleRequestDetailsPopup: boolean = false;
  private ExportType = ExportType
  private gridData: any = [];
  private checkBoxCheckAllProperty = false;
  private showFileSelectionError: boolean = false
  private errorMessageAfterApprove: string = ""
  private dontSendMessage: boolean = false
  private showDontSendMassage: boolean = false
  private errorMessage: string = ""
  private tabIndex: number = 0;
  private DEFAULT_PAGE_SIZE: number = 10;

  private styleGridTimeout: any = null;
  private isMangingCompanyStatusChanged: boolean = false

  private personalDetailsEditSection: any = {
    bankAccountNumber: "",
    bankBranchName: "",
    bankName: "",
    memberName: "",
    dateUpdated: "",
    idNumber: "",
    accountNumber: ""
  }

  private allStatusType: KeyValuePair[] = [];
  private loanStatusStyleMap: any = {
    'REQUEST_SUBMIT': "#0000ff",
    'FIRST_APPROVE': "#008000",
    'SECOND_APPROVE': "#008000",
    'REJECTED': "#ee0000",
    'UNDER_EXAMINATION': "#9e6d14"
  }
  private remarkDescription: string = '';
  private privateRemarkDescription: string = '';
  private emptyBody: string = '';
  private showRemark: boolean = false;
  private problemWithApplication: boolean = false;
  private sendExtraText: boolean = false;
  private loanTypes: KeyValuePair[] = [];
  private archive: KeyValuePair[] = [];

  private userDetailsFields: any = [
    {key: 'dateUpdated', label: i18n.t('requestManagement.popup.updateStatus')},
    {key: 'lastUpdateName', label: i18n.t('requestManagement.popup.updateStatus')},
    {key: 'lastUpdateStatus', label: i18n.t('requestManagement.popup.updateStatus')},
    {
      key: 'managementCompanyReasons',
      label: i18n.t('requestManagement.popup.updateStatus'),
      formatter: (value: { toLocaleString: () => string; }) => value.toLocaleString() + ' ₪'
    },
  ];

  beforeMount() {
    this.hasFeedback = true
  }

  beforeDestroy() {
    if (this.styleGridTimeout) {
      clearTimeout(this.styleGridTimeout)
    }
  }

  mounted() {



    this.loanTypes = [
      {value: "11", description: "בקשת הלוואה"},
      {value: "16", description: "מיחזור הלוואה"}];

    this.archive = [
      {value: "true", description: "כן"},
      {value: "false", description: "לא"}];

    this.getLoansManagementSettings({requestorCallback: this})

    this.initColumns();


    this.processTypeCode = this.rejectApplication.processTypeCode;
    this.memberProcessId = this.rejectApplication.processTypeCode;
    this.description = this.rejectApplication.processTypeCode;
  }

  private initRejectOptionsInPopupSelection() {
    this.rejectStatusesSelection = [...this.rejectStatuses]
  }


  private initUnderExaminationReasonInPopupSelection() {
    this.underExaminationStatusesSelection = [...this.underExaminationStatuses]

  }

  created() {

    this.$on('successResults', (data: any, index: number) => {

      if (this.styleGridTimeout) {
        clearTimeout(this.styleGridTimeout)
      }

      this.styleGridTimeout = setTimeout(() => {
        for (const key in this.loanStatusStyleMap) {
          const loanStatus = this.allStatusType.find((ls: any) => ls.value == key);
          if (loanStatus) {
            $('td.loanStatusType\\.value:contains("' + loanStatus.description + '")').css('color', this.loanStatusStyleMap[key]).css('font-size', '18px')

          }
        }
      }, 0)
    })
  }


  onError(messages: string[], code: number, requestName?: string): void {
    switch (requestName) {
      case 'updateAttachedFiles':
      case 'createOrUpdateCompanyDocuments':
        this.showFileSelectionError = true;
        break;

      case 'approveApplications':
        const errorMessage: string = messages[0] ? messages[0] : ''
        this.showErrorNotAuthZ(errorMessage)
        break
    }
  }

  showErrorNotAuthZ(errorMessage: string) {
    this.errorMessageAfterApprove = errorMessage;
    this.problemWithApplication = true;
    this.getGridData({
      ...this.searchObject
    })
  }

  private initSearchLoansFields(): void {
    if (this.allStatusType === null || this.allStatusType.length === 0) {
      return;
    }

    this.searchLoansFields.push({
      label: 'requestManagement.loanTypes',
      property: 'processTypeCode',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.loanTypes,
      unSelectFirst: true,
      bootstrapColumn: 3
    })
    this.searchLoansFields.push({
      label: 'requestManagement.requestStatus',
      property: 'loanStatusType',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.allStatusType,
      unSelectFirst: true,
      bootstrapColumn: 3
    })
    this.searchLoansFields.push({
      label: 'requestManagement.managementLoanExtraStatus',
      property: 'managementLoanExtraStatus',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.archive,
      unSelectFirst: false,
      bootstrapColumn: 3,
      dontAddDefaultSelect: true,
      initialSelected: this.archive[1]
    })
    this.searchLoansFields.push({
      label: 'requestManagement.memberId',
      property: 'memberIdNum',
      fieldType: FieldType.TEXT_FIELD,
      maxLength: 16,
      advancedOnly: false,
      bootstrapColumn: 3
    })
    this.searchLoansFields.push({
      label: 'requestManagement.memberName',
      property: 'fullName',
      fieldType: FieldType.TEXT_FIELD,
      advancedOnly: true,
      bootstrapColumn: 3
    })
    this.searchLoansFields.push({
      label: 'requestManagement.requestSubmitDate',
      property: 'applicationDate',
      fieldType: FieldType.DATE_FIELD,
      bootstrapColumn: 3,
      advancedOnly: true,
    })
  }

  private initColumns(): void {
    this.columns.push({property: 'loanStatusType.value', header: 'requestManagement.requestStatus'} as GridColumn)
    this.columns.push({
      property: 'requestType',
      header: 'requestManagement.requestType',
      hideSorting: true
    } as GridColumn)
    this.columns.push({property: 'dateCreated', header: 'requestManagement.requestSubmitDate'} as GridColumn)
    this.columns.push({property: 'memberIdNum', header: 'requestManagement.idNumber'} as GridColumn)
    this.columns.push({property: 'fullName', header: 'requestManagement.fullName', hideSorting: true} as GridColumn)
    this.columns.push({property: 'accountNum', header: 'requestManagement.accountNumber'} as GridColumn)
    this.columns.push({
      property: 'loanAmount',
      header: 'requestManagement.loanOrWithdrawalRequestedAmount', hideSorting: true
    } as GridColumn)
    this.columns.push({property: 'grace', header: 'requestManagement.interest', hideSorting: true} as GridColumn)
    this.columns.push({
      property: 'loanType.value',
      header: 'requestManagement.loanType',
      hideSorting: true
    } as GridColumn)
    this.columns.push({property: 'loanTime', header: 'requestManagement.refundPeriod', hideSorting: true} as GridColumn)
    this.columns.push({
      property: 'ratingType.value',
      header: 'requestManagement.rating',
      hideSorting: true
    } as GridColumn)
  }

  private searchObject: any = {}
  private getGridData(searchObject: any): void {

    this.searchObject = searchObject;
    this.fetchLoanRequest({
      requestorCallback: this,
      requestBody: {...searchObject}
    })
  }


  isFinalStatus() {
    if (this.rowSelected.loanStatusType && (this.rowSelected.loanStatusType.key === 3 || this.rowSelected.loanStatusType.key === 2)) {
      return true;
    } else {
      return false;
    }
  }

  private getStatus(): number {
    let result: number = 0;
    if (this.rowSelected.loanStatusType) {
      if (this.rowSelected.loanStatusType.key === 3) {
        result = 1;
      }
    }

    return result;
  }


  onRowClick(res: any) {
    this.rowSelected = res;
    this.showDontSendMassage = true;

    this.initPersonalDetailsForEditDocumentsSection(res)

    if (this.isFinalStatus()) {
      this.rowSelected.loanApprovalDetailsFormData.loanApplicationSelect = this.getStatus();
    }
    this.remarkDescription = '';
    this.privateRemarkDescription = '';
    this.showRemark = true;
    this.showSingleRequestDetailsPopup = true;
  }

  closeSingleRequestDetailsPopup() {
    this.showSingleRequestDetailsPopup = false;
    this.showRemark = false;
    this.dontSendMessage = false;
    this.showDontSendMassage = false;
    this.tabIndex = 0;
  }



  afterManagingCompanySuccessUpdated() {

    this.isMangingCompanyStatusChanged = !this.isMangingCompanyStatusChanged;


    this.getGridData({
      ...this.searchObject
    });
    this.closeSingleRequestDetailsPopup()
    this.$emit('successResults')
  }

  afterMemberPdfUpdated() {
    this.isMangingCompanyStatusChanged = !this.isMangingCompanyStatusChanged;
  }


  private showSuccessAction() {
    if (!this.problemWithApplication) {
      this.$root.$emit('showAlertNotification', {
        toShow: true,
        message: 'requestManagement.popup.loanRequestUpdatedSuccessfully',
        icon: 'checkCircle',
        secondsToDisappear: 3
      })
    }
  }

  private showAlertNotification() {
    this.$root.$emit('showAlertNotification', {
      toShow: true,
      message: 'requestManagement.popup.loanRequestUpdatedSuccessfully',
      icon: 'checkCircle',
      secondsToDisappear: 3
    })
  }

  private closePopupProblem(): void {
    this.problemWithApplication = false;
  }

  private approveLoanRequest(allIds: string[]): void {
    this.approveApplications({
      requestorCallback: this,
      requestBody: {
        memberProcessIds: allIds,
        privateDescription: this.privateRemarkDescription,
        dontSendMassageToTheClient: this.dontSendMessage
      }
    })
  }


  initPersonalDetailsForEditDocumentsSection(data: any) {
    this.personalDetailsEditSection.memberName = data.fullName;
    this.personalDetailsEditSection.bankAccountNumber = data.bankAccountNumber;
    this.personalDetailsEditSection.bankName = data.bankName;
    this.personalDetailsEditSection.bankBranchName = data.bankBranchName;
    this.personalDetailsEditSection.dateUpdated = data.dateUpdated;
    this.personalDetailsEditSection.idNumber = data.memberIdNum;
    this.personalDetailsEditSection.accountNumber = data.accountNum;
  }


  onSuccess(data ?: any, requestName ?: string, message ?: string, success ?: boolean): void {
    switch (requestName) {
      case 'fetchLoanRequest':
        this.gridData = data.results.map((result: any) => {
          return ({...result, loanApprovalDetailsFormData: {}, isCheckBoxSelected: false});
        })
        this.$emit('successResults', {
          ...data, results: this.gridData
        })
        break

      case 'downloadLoanApplication':
        this.$emit('successExport', data)
        break
      case 'downloadLoanRatingType':
        this.$emit('successExport', data)
        break
      case 'getLoansManagementSettings':
        this.initKeyValue(this.allStatusType, data.loanStatusTypes);
        this.sendExtraText = data.sendExtraText
        this.rejectStatuses = data.rejectStatuses;
        this.underExaminationStatuses = data.underExaminationStatuses;

        this.initRejectOptionsInPopupSelection()
        this.initUnderExaminationReasonInPopupSelection()
        this.initSearchLoansFields()
        break


      case 'exportLoansDetails':
        this.$emit('successExport', data)
        break

      case 'approveApplications':
        this.afterManagingCompanySuccessUpdated()
        this.checkBoxCheckAllProperty = false
        this.showSuccessAction();
        break
    }
  }



  private initKeyValue(arrayToFill: KeyValuePair[], data: any[]): void {
    for (const element of data) {
      const translateDescription: any = this.$t("requestManagement." + element.name);
      arrayToFill.push({
        value: element.name,
        description: translateDescription
      })
    }
  }

  onExportGrid(exportType: ExportType, gridColumns: Array<GridColumn>, searchObject: any): void {
    let exportColumns: GridColumn[] = []
    this.exportLoansDetails({
      requestBody: {
        headerText: this.exportFileName,
        exportType: exportType,
        columnsList: exportColumns,
        searchObject: searchObject
      } as BaseRequest,
      requestorCallback: this
    })
  }

  private filterGridById(numberOfLoanRequests: number) {
    this.closeSingleRequestDetailsPopup()
    this.searchObject.pageSize = numberOfLoanRequests
    this.searchObject = {
      ...this.searchObject,
      memberIdNum: this.rowSelected.memberIdNum
    }
    this.getGridData({
      ...this.searchObject
    })
    this.searchObject.pageSize = this.DEFAULT_PAGE_SIZE
  }

  closeErrorPopup() {
    this.showFileSelectionError = false;
    this.errorMessage = ""
  }


  private onCheckboxClick(checked: boolean, result: any) {
    if (!checked) {
      this.checkBoxCheckAllProperty = false;
    }

    this.showSingleRequestDetailsPopup = false

    this.gridData.forEach((row: any) => {
      if (row.id === result.id) {
        row.isCheckBoxSelected = checked;
      }
    });
    this.bindGridData(this.gridData)
  }

  private onAcceptToolbarButtonClicked() {
    const selectedRows: string[] = this.gridData.filter((row: any) => row.isCheckBoxSelected).map((row: any) => row.memberProcessId)

    if (selectedRows.length > 0) {
      this.approveLoanRequest(selectedRows);
    }
  }

  private onCheckboxCheckAll(checkAll: boolean) {

    this.checkBoxCheckAllProperty = checkAll;

    this.gridData.forEach((row: any) => {
      row.isCheckBoxSelected = checkAll
    });
    this.bindGridData(this.gridData)
  }

  bindGridData(data: object[]): void {
    this.$emit('successResults', {
      results: data,
      hasMore: false,
      resultCount: data.length
    });
  }


  get exportFileName(): string {
    return '' + this.$t('requestManagement.fileName')
  }

  onExportClick(data: any) {
    this.downloadLoanApplication({
      requestorCallback: this,
      pathVariable: data.memberProcessId
    })
  }
}
